const ShowMap = ({ checked, handleCheckboxOnChange }: any) => {
  return (
    <div className="flex gap-2">
      <input
        type="checkbox"
        checked={checked}
        onChange={handleCheckboxOnChange}
        id="showMap"
        className="w-4"
      />
      <label
        htmlFor="showMap"
        className="cursor-pointer text-secondaryMidLight"
      >
        Show map
      </label>
    </div>
  );
};

export { ShowMap };
